var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tabs',{attrs:{"type":"border-card"}},[_c('el-tab-pane',{attrs:{"label":"托运人资料"}},[_c('shipmentAdd',{attrs:{"parent-data":_vm.parentData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }